export default __webpack_public_path__ + "static/media/Hewlett_Packard_Enterprise_logo.b45b81a2.svg";